import { d as darkTheme, l as lightTheme, k as kyteTheme } from './kyte-15420865.js';

const themes = {
  dark: darkTheme,
  light: lightTheme,
  kyte: kyteTheme
};

export { themes as default };
//# sourceMappingURL=themes.js.map
